import { useState } from "react";
import { logTopicRecommendationsGradingSystemViewed } from "../util/analytics";

export default function useRecommendationsGrading() {
  const [
    isRecommendationsGradingDialogOpen,
    setIsRecommendationsGradingDialogOpen,
  ] = useState(false);

  const handleRecommendationsGradingDialogOpen = ({
    affordance,
    telemetryData,
  }) => {
    setIsRecommendationsGradingDialogOpen(true);
    logTopicRecommendationsGradingSystemViewed({
      affordance,
      ...telemetryData,
    });
  };

  const handleRecommendationsGradingDialogCancel = () => {
    setIsRecommendationsGradingDialogOpen(false);
  };

  return {
    isRecommendationsGradingDialogOpen,
    handleRecommendationsGradingDialogOpen,
    handleRecommendationsGradingDialogCancel,
  };
}
